import React from 'react';
import { Grid, Typography, Box, useMediaQuery, useTheme } from '@mui/material';

// Custom styles for different screen sizes
const PartnerCard = () => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const isSm = useMediaQuery(theme.breakpoints.only('sm'));
  const isMd = useMediaQuery(theme.breakpoints.only('md'));
  const isLg = useMediaQuery(theme.breakpoints.up('lg'));
  const is4K = useMediaQuery("(min-width: 3840px)");
  const is900to1024 = useMediaQuery('(min-width:900px) and (max-width:1224px)');
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  // Dynamic font sizes based on screen size
  const fontSizes = {
    cardTitle: isXs ? 18 : isSm ? 20 : isMd ? 20 : 20,
    cardSubtitle: isXs ? 30 : isSm ? 30 : isMd ? 30 : 35,
    cardBody: isXs ? 16 : isSm ? 18 : isMd ? 18 : 18,
  };

  const cards = [
    {
      id: 1,
      title: "Technology Partnerships",
      subtitle: "Google Cloud Partner",
      content:
        "As a certified partner, we bring you cutting-edge Google Cloud solutions, ensuring expert implementation, scalability, and security for your digital initiatives.",
      image: (
        <img
          src="/Google_Cloud_Partner_no_outline_vertical_1.webp"
          srcSet="/Google_Cloud_Partner_no_outline_vertical-200w.png 200w, /Google_Cloud_Partner_no_outline_vertical_1.webp 400w"
          sizes="(max-width: 600px) 200px, 400px"
          alt="Google Cloud Partner"
          width={200} // Explicit width
          height={400} // Adjust based on actual image dimensions
          style={{
            maxWidth: "200px",
            height: "auto",
            display: "block",
            // margin: "auto",
            objectFit: "contain",
          }}
        />
      ),
    },
    {
      id: 2,
      title: "Industry Memberships",
      subtitle: "Nasscom Member",
      content:
        "Our association with Nasscom reinforces our commitment to industry best practices, continuous learning, and contributing to the advancement of the IT sector.",
      image: (
        <img
          src="/nasscom.webp"
          alt="Nasscom Member"
          width={200} // Explicit width
          height={300} // Adjust based on actual SVG dimensions
          style={{
            maxWidth: "200px",
            height: "auto",
            display: "block",
            margin: "auto",
            objectFit: "contain",
            preserveAspectRatio: "xMidYMid meet",
            transform: "translateX(-5px)",
          }}
        />
      ),
    },
  ];

  const paddingLeft = is4K ? '1200px' : is900to1024 ? '51px' : '210px';
  const paddingRight = is4K ? '1200px' : is900to1024 ? '50px' : '214px';

  return (
    <Box sx={{
      pl: { xs: 2, sm: 2, md: paddingLeft },
      pr: { xs: 2, sm: 0, md: paddingRight },
      pt: { xs: 4, sm: 6, md: 8 },
      pb: { xs: 4, sm: 6, md: 14 },
      maxWidth: '100%',
    }}>
      <Box
        sx={{
          
          width: "100%",
          height: "auto",
          display: "flex",
          alignContent:'center',
          justifyContent:'center',
         // bgcolor: "#FAFBFC",
         
        }}
      >
      {/* Cards Grid */}
      <Grid
          container
          spacing={3}
          sx={{ maxWidth: "1450px",            alignContent:'center',
            justifyContent:'center', }}
        >
        {cards.map((card, index) => (
          <Grid item xs={12} sm={9} md={6} key={card.id}>
            <Box
              sx={{
                p: { xs: 3, sm: 4, md: 3, lg: 4 },
                borderRadius: '15px',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                
                backgroundColor: 'white',
                boxShadow: " rgba(0, 0, 0, 0.15) 0px 2px 8px", // Darker shadow for depth
                  mt: "25px",
                   
                  flexGrow: 1, // Ensures equal height
                  height: "100%", // Forces uniform height
                // border: '0.5px solid rgba(0, 0, 0, 0.22)'
              }}
            >
              {/* Image */}
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  mb: 3,
                  width: '100%',
                  height: '200px', // Fixed height for consistency
                  overflow: 'hidden', // Prevents overflow from affecting centering
                }}
              >
                {card.image}
              </Box>
              <Typography
                sx={{
                  fontSize: fontSizes.cardSubtitle,
                  fontFamily: 'Lexend, sans-serif',
                  fontWeight: 400,
                  textAlign: 'center',
                  color: '#000000DE',
                  mb: 2
                }}
              >
                {card.subtitle}
              </Typography>

              {/* Card Content */}
              <Typography
                sx={{
                  fontSize: fontSizes.cardBody,
                  fontFamily: 'Lexend, sans-serif',
                  lineHeight: 1.6,
                  textAlign: 'center',
                  fontWeight: 300,
                  color: '#000000DE'
                }}
              >
                {card.content}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid></Box>
    </Box>
  );
};

export default PartnerCard;